import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/AboutView.vue"),
  },
  {
    path: "/membership",
    name: "membership",
    component: () =>
      import(/* webpackChunkName: "membership" */ "@/views/MembershipView.vue"),
  },
  {
    path: "/bylaws",
    name: "bylaws",
    component: () =>
      import(/* webpackChunkName: "bylaws" */ "@/views/BylawsView.vue"),
  },
  {
    path: "/codeofconduct",
    name: "codeofconduct",
    component: () =>
      import(/* webpackChunkName: "bylaws" */ "@/views/CodeOfConduct.vue"),
  },
  {
    path: "/styles",
    name: "styles",
    component: () =>
      import(/* webpackChunkName: "styles" */ "@/views/BeerStylesView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "@/views/ContactView.vue"),
  },
  {
    path: "/boty",
    name: "boty",
    component: () =>
      import(/* webpackChunkName: "boty" */ "@/views/BoTYView.vue"),
  },
  {
    path: "/event/:id?",
    name: "event",
    component: () =>
      import(/* webpackChunkName: "comp" */ "@/views/EventView.vue"),
  },
  {
    path: "/events",
    name: "events",
    component: () =>
      import(/* webpackChunkName: "comp" */ "@/views/EventsView.vue"),
  },
  {
    path: "/blog/:id?",
    name: "blog",
    component: () =>
      import(/* webpackChunkName: "calendar" */ "@/views/BlogView.vue"),
  },
  {
    path: "/unsubscribe/:id?",
    name: "unsubscribe",
    component: () =>
      import(
        /* webpackChunkName: "subscription" */ "@/views/SubscriptionView.vue"
      ),
  },
  {
    path: "/subscribe/:id?",
    name: "subscribe",
    component: () =>
      import(
        /* webpackChunkName: "subscription" */ "@/views/SubscriptionView.vue"
      ),
  },
  {
    path: "/2026-membership-signup",
    name: "SubscribeNewMember",
    component: () =>
      import(
        /* webpackChunkName: "SubscribeNewMember" */ "@/views/SubscribeNewMemberView.vue"
      ),
  },
  {
    path: "/members/:code?",
    name: "Member Links",
    component: () =>
      import(/* webpackChunkName: "MembersView" */ "@/views/MembersView.vue"),
  },
  {
    path: "/banner",
    name: "banner",
    component: () =>
      import(/* webpackChunkName: "subscription" */ "@/views/Banner.vue"),
  },
  {
    path: "/survey",
    name: "survey",
    component: () =>
      import(/* webpackChunkName: "survey" */ "@/views/Survey.vue"),
  },
  {
    path: "/:PathMatch(.*)*",
    name: "not-found",
    component: () =>
      import(/* webpackChunkName: "not-found" */ "@/views/PageNotFound.vue"),
  },
];

const router = createRouter({
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
